export default __webpack_public_path__ + "static/media/inter-medium.cc6a8868.woff";